const normalizeOrigin = (value?: string) => {
  if (!value) {
    return null
  }

  try {
    const url = new URL(value)
    return url.origin
  } catch {
    return null
  }
}

export const getAppOrigin = () => {
  const configuredOrigin = normalizeOrigin(import.meta.env.VITE_APP_URL)
  if (configuredOrigin) {
    return configuredOrigin
  }

  if (typeof window !== 'undefined') {
    return window.location.origin
  }

  return null
}
